import React from 'react';
import {ArrowPathIcon} from '@heroicons/react/24/outline';

interface ISpinnerProps {}

const Spinner = ({}: ISpinnerProps) => {
  return (
    <div className="bg-primary p-3 rounded-full">
      <ArrowPathIcon className="size-8 text-white animate-spin" />
    </div>
  );
};

export default React.memo(Spinner);
